import { WEBHOOK_ENDPOINTS } from '../config/webhook-urls';
import { n8nFetch } from './n8n-fetch';

// Серверная проверка сессии (app_users.session_version через /webhook/auth-check).
// Сессия сама по себе — localStorage на 30 дней; без этой проверки смена пароля
// не выкидывала пользователя с уже залогиненного компьютера.
//
// Fail-open: false возвращаем ТОЛЬКО когда сервер явно ответил { ok: false }.
// Сеть/таймаут/404 (n8n или миграция ещё не выкачены) → сессия живёт.

export const SESSION_VERSION_KEY = 'analytics-session-version';

// Не чаще раза в минуту: keep-alive вкладки монтируют несколько AuthWrapper,
// плюс проверка дёргается на каждом возврате во вкладку.
const MIN_INTERVAL_MS = 60 * 1000;
let lastCheckedAt = 0;
let inflight = null;

// Сразу после логина проверять нечего — сессия только что выдана сервером.
export const markSessionChecked = () => {
  lastCheckedAt = Date.now();
};

// Сессии, сохранённые до появления версии, считаются поколением 1 (default колонки).
const storedSessionVersion = () => {
  const v = parseInt(localStorage.getItem(SESSION_VERSION_KEY) || '', 10);
  return Number.isInteger(v) && v > 0 ? v : 1;
};

export const verifySession = ({ force = false } = {}) => {
  if (typeof window === 'undefined') return Promise.resolve(true);
  if (inflight) return inflight;
  if (!force && Date.now() - lastCheckedAt < MIN_INTERVAL_MS) return Promise.resolve(true);

  const username = localStorage.getItem('analytics-username');
  if (!username) return Promise.resolve(true);

  inflight = (async () => {
    try {
      const res = await n8nFetch(WEBHOOK_ENDPOINTS.AUTH_CHECK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, session_version: storedSessionVersion() }),
        timeoutMs: 8000,
      });
      if (!res.ok) return true;
      const data = await res.json();
      return !(data && data.ok === false);
    } catch {
      return true;
    } finally {
      lastCheckedAt = Date.now();
      inflight = null;
    }
  })();
  return inflight;
};
